import { useDispatch } from 'react-redux';
import { openModal, setModalData } from '~/Redux/Modules/Modal';
import { UPGRADE_TO_LIFETIME_MODAL } from '~/Config/Modals';

const useUpgradeToLifetime = () => {
  const dispatch = useDispatch();

  const manageUpgradeToLifetime = opts => {
    const deferred = {};
    const confirmPromise = new Promise((resolve, reject) => {
      deferred.resolve = resolve;
      deferred.reject = reject;
    });
    return new Promise((resolve, reject) => {
      dispatch(openModal(UPGRADE_TO_LIFETIME_MODAL));
      dispatch(setModalData({ confirmPromise: deferred, ...opts }));
      confirmPromise
        .then(() => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  return manageUpgradeToLifetime;
};

export default useUpgradeToLifetime;
